/**
 * @package Once JS
 * @author Bearsthemes
 * @version 1.0.0
 */

var $ = jQuery.noConflict();

$.fn._once = function( _fn ) {
  return $(this).each(function() {
    var $thisEl = $(this);
        IsOnce = $thisEl.data('is-once');

    if(IsOnce == true) return;
    
    $thisEl.data('is-once', true);
    _fn.call(this, $thisEl);
  })
}

module.exports = function() {}
